import React from 'react';
import SimpleModal from '../../../SimpleModal/SimpleModal';
import { DropdownMenu } from '../../../DropdownMenu';
import { SELECTABLE_VIZUALISATIONS } from '../../../../constants';

export default function FullscreenModal({
  visualization,
  handleExportData,
  onSelect,
  openSignalViewer,
  onClose,
  Component,
}) {
  function FullscreenOptions() {
    const options = [];
    if (SELECTABLE_VIZUALISATIONS.includes(visualization.type)) {
      options.push({
        component: <div>Download</div>,
        onSelect: () => {
          onSelect(visualization);
          handleExportData();
        },
      });
      options.push({
        component: <div>Open in Signal viewer</div>,
        onSelect: () => {
          openSignalViewer(visualization);
          onClose();
        },
      });
    }

    if (!options.length) {
      return null;
    }

    return (
      <>
        <DropdownMenu
          trigger="he-moreoptionshorizontal"
          triggerSize="s"
          className="visualization-modal-menu"
          menuOptions={options}
          menuXPlacement="left"
          styles={{
            dropdownIndicator: { padding: '0 0.5rem', filter: 'none' },
            option: { cursor: 'pointer' },
          }}
        />
      </>
    );
  }

  return (
    <SimpleModal
      title={visualization.name}
      size="l"
      onClose={onClose}
      headerRight={<FullscreenOptions />}
      className="visualization-fullscreen-modal"
    >
      <div className="corevisualization-component visualization-fullscreen">{Component}</div>
    </SimpleModal>
  );
}
